module.exports = __webpack_public_path__ + "static/media/small-email-icon.8df041b3.svg";